export const gu = {
  // Navigation (Gujarati)
  explore: 'અન્વેષણ',
  search: 'શોધ',
  create: 'પોસ્ટ બનાવો',
  messages: 'સંદેશાઓ',
  notifications: 'સૂચનાઓ',
  settings: 'સેટિંગ્સ',
  profile: 'પ્રોફાઇલ',
  logout: 'લોગ આઉટ',
  home: 'હોમ',
  
  // Authentication
  signin: 'સાઇન ઇન',
  signup: 'સાઇન અપ',
  login: 'લોગિન',
  register: 'નોંધણી',
  email: 'ઇમેઇલ',
  password: 'પાસવર્ડ',
  confirmPassword: 'પાસવર્ડની પુષ્ટિ કરો',
  firstName: 'પ્રથમ નામ',
  lastName: 'છેલ્લું નામ',
  forgotPassword: 'પાસવર્ડ ભૂલી ગયા?',
  alreadyHaveAccount: 'પહેલેથી એકાઉન્ટ છે? સાઇન ઇન કરો',
  dontHaveAccount: 'એકાઉન્ટ નથી? સાઇન અપ કરો',
  
  // Posts & Content
  recent: 'તાજેતરના',
  trending: 'ટ્રેન્ડિંગ',
  popular: 'લોકપ્રિય',
  like: 'પસંદ',
  likes: 'પસંદ',
  comment: 'ટિપ્પણી',
  comments: 'ટિપ્પણીઓ',
  share: 'શેર',
  delete: 'કાઢી નાખો',
  edit: 'સંપાદિત કરો',
  post: 'પોસ્ટ',
  posts: 'પોસ્ટ્સ',
  title: 'શીર્ષક',
  content: 'સામગ્રી',
  tags: 'ટેગ્સ',
  noBlogsFound: 'કોઈ બ્લોગ મળ્યા નથી. કંઈક બીજું શોધવાનો પ્રયાસ કરો અથવા પ્રથમ બનાવો!',
  
  // AI Assistant
  quickActions: 'ઝડપી ક્રિયાઓ',
  writeCaption: 'કેપ્શન લખો',
  suggestTopics: 'વિષયો સૂચવો',
  improveContent: 'સામગ્રી સુધારો',
  creativeIdeas: 'સર્જનાત્મક વિચારો',
  clearChat: 'ચેટ સાફ કરો',
  aiWritingAssistant: 'AI લેખન સહાયક',
  poweredByGroq: 'GROQ AI દ્વારા સંચાલિત',
  aiGreeting: 'નમસ્તે! હું તમારો AI લેખન સહાયક છું. હું તમને આકર્ષક સામગ્રી બનાવવામાં, કેપ્શન લખવામાં, પોસ્ટ વિષયો સૂચવવામાં અને તમારા લેખનને સુધારવામાં મદદ કરી શકું છું. આજે તમે શું પર કામ કરવા માંગો છો?',
  askMeToHelp: 'સામગ્રી, કેપ્શન, વિષયો અથવા લેખન સાથે મદદ માટે મને પૂછો...',
  aiThinking: 'AI વિચારી રહ્યું છે...',
  
  // Chat & Messages
  chat: 'ચેટ',
  noConversationsYet: 'હજુ સુધી કોઈ વાતચીત નથી',
  ideafluxChat: 'IdeaFlux ચેટ',
  typeMessage: 'સંદેશ ટાઇપ કરો...',
  sendMessage: 'સંદેશ મોકલો',
  connectingToChat: 'ચેટ સાથે કનેક્ટ થઈ રહ્યું છે...',
  
  // Notifications
  noNotificationsYet: 'હજુ સુધી કોઈ સૂચનાઓ નથી।',
  markAllRead: 'બધાને વાંચ્યા તરીકે ચિહ્નિત કરો',
  clearAll: 'બધું સાફ કરો',
  
  // Settings
  accountSettings: 'એકાઉન્ટ સેટિંગ્સ',
  displayName: 'ડિસ્પ્લે નામ',
  emailAddress: 'ઇમેઇલ સરનામું',
  languagePreference: 'ભાષા પસંદગી',
  privacySecurity: 'ગોપનીયતા અને સુરક્ષા',
  notificationPreferences: 'સૂચના પસંદગીઓ',
  allowDirectMessages: 'સીધા સંદેશાઓની મંજૂરી આપો',
  letOthersMessage: 'અન્ય વપરાશકર્તાઓને તમને ખાનગી સંદેશાઓ મોકલવાની મંજૂરી આપો',
  likesOnPosts: 'પોસ્ટ્સ પર પસંદ',
  commentsOnPosts: 'પોસ્ટ્સ પર ટિપ્પણીઓ',
  newFollowers: 'નવા ફોલોઅર્સ',
  mentions: 'ઉલ્લેખો',
  save: 'સેવ કરો',
  deleteAccount: 'એકાઉન્ટ કાઢી નાખો',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'જ્યારે કોઈ સૂચના મેળવો',
  likesYourPosts: 'તમારી પોસ્ટ્સ પસંદ કરે',
  commentsOnYourPosts: 'તમારી પોસ્ટ્સ પર ટિપ્પણી કરે',
  followsYou: 'તમને ફોલો કરે',
  mentionsYou: 'તમારો ઉલ્લેખ કરે',
  chooseNotifications: 'તમે કઈ સૂચનાઓ મેળવવા માંગો છો તે પસંદ કરો',
  controlWhoInteracts: 'કોણ તમારી સાથે વાતચીત કરી શકે તે નિયંત્રિત કરો',
  manageAccountInfo: 'તમારી એકાઉન્ટ માહિતી અને પસંદગીઓનું સંચાલન કરો',
  emailCannotBeChanged: 'સુરક્ષા કારણોસર ઇમેઇલ બદલી શકાતું નથી',
  
  // Common
  loading: 'લોડ થઈ રહ્યું છે...',
  cancel: 'રદ કરો',
  update: 'અપડેટ કરો',
  submit: 'સબમિટ કરો',
  back: 'પાછળ',
  next: 'આગળ',
  previous: 'પહેલાં',
  online: 'ઓનલાઇન',
  offline: 'ઓફલાઇન',
  
  // Profile
  editProfile: 'પ્રોફાઇલ સંપાદિત કરો',
  noBioYet: 'હજુ સુધી કોઈ બાયો નથી।',
  followers: 'ફોલોઅર્સ',
  following: 'ફોલોઇંગ',
  recentActivity: 'તાજેતરની પ્રવૃત્તિ',
  noPostsYet: 'હજુ સુધી કોઈ પોસ્ટ્સ નથી',
  shareFirstPost: 'તમારી પ્રથમ પોસ્ટ શેર કરો!',
  bio: 'બાયો',
  dateOfBirth: 'જન્મ તારીખ',
  follow: 'ફોલો કરો',
  unfollow: 'અનફોલો કરો',
  
  // Search
  discover: 'શોધો',
  findPeopleStories: 'તમારા માટે મહત્વપૂર્ણ લોકો, વાર્તાઓ અને વિચારો શોધો',
  searchByName: 'નામ, શીર્ષક અથવા #ટેગ દ્વારા શોધો...',
  searchResults: 'શોધ પરિણામો',
  noResultsFound: 'કોઈ પરિણામો મળ્યા નથી',
  peopleFound: 'લોકો મળ્યા',
  
  // Settings - Additional keys
  enterDisplayName: 'તમારું ડિસ્પ્લે નામ દાખલ કરો',
  saving: 'સેવ થઈ રહ્યું છે...',
  confirmDeleteAccount: 'શું તમે ખરેખર તમારું એકાઉન્ટ કાઢી નાખવા માંગો છો? આ પૂર્વવત્ કરી શકાતું નથી.',
  accountDeletedSuccessfully: 'એકાઉન્ટ સફળતાપૂર્વક કાઢી નાખવામાં આવ્યું.',
  errorDeletingAccount: 'એકાઉન્ટ કાઢી નાખવામાં ભૂલ. કૃપા કરીને ફરી પ્રયાસ કરો.',
  settingsSavedSuccessfully: 'સેટિંગ્સ સફળતાપૂર્વક સેવ થઈ!',
  failedToSaveSettings: 'સેટિંગ્સ સેવ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.',
  
  // Form component
  pleaseSignInToCreate: 'પોસ્ટ બનાવવા માટે સાઇન ઇન કરો।',
  titleRequired: 'પોસ્ટ પ્રકાશિત કરવા માટે શીર્ષક જરૂરી છે।',
  contentRequired: 'પોસ્ટ પ્રકાશિત કરવા માટે વાર્તા સામગ્રી જરૂરી છે।',
  contentTooShort: 'વાર્તા સામગ્રી ઓછામાં ઓછી 10 અક્ષરોની હોવી જોઈએ।',
  postUpdatedSuccessfully: 'પોસ્ટ સફળતાપૂર્વક અપડેટ થઈ!',
  postPublishedSuccessfully: 'પોસ્ટ સફળતાપૂર્વક પ્રકાશિત થઈ!',
  pleaseSignInToCreateBlogs: 'તમારા પોતાના IdeaFlux બ્લોગ બનાવવા માટે સાઇન ઇન કરો।',
  enterEngagingTitle: 'આકર્ષક શીર્ષક દાખલ કરો...',
  story: 'વાર્તા',
  writeYourMasterpiece: 'તમારી કૃતિ લખો...',
  addTags: 'ટેગ્સ ઉમેરો...',
  add: 'ઉમેરો',
  publishPost: 'પોસ્ટ પ્રકાશિત કરો',
  
  // Post component
  linkCopiedToClipboard: 'લિંક ક્લિપબોર્ડમાં કોપી થઈ! શેર કાઉન્ટ અપડેટ થયું.',
  youAndOthers: 'તમે અને {{count}} અન્ય',
  unknownUser: 'અજાણ્યા વપરાશકર્તા',
  noImage: 'કોઈ છબી નથી',
  deletePost: 'પોસ્ટ કાઢી નાખો',
  confirmDeletePost: 'શું તમે ખરેખર આ પોસ્ટ કાઢી નાખવા માંગો છો?',
};